module.exports = __webpack_public_path__ + "img/vision1.78c62f1d.png";